import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/config";
import { Notification } from "../Notification";

//TYPES OF NOTIFICATIONS - Naming
// GA - Group Approved
// GR - Group Removed
// GU - Group Updated
// CA - Client Added
// CR - Client Removed

export const AddNotification = (item, type, user) => {
   //notifications refference
   const notifRef = collection(db, "notifications");

   //switch evalauates type of addNotification
   switch (type) {
      case "GA":
         try {
            addDoc(notifRef, {
               date: serverTimestamp(),
               desc: `Admin ${user.email} has approved "${item.groupName}"`,
               seen: false,
               type: "Group Approved",
               uid: item.user,
               userEmail: item.userEmail,
               groupId: item.id,
               groupName: item.groupName,
            });
         } catch (error) {
            Notification("error", "Notification error", error.message);
         }
         break;
      case "GR":
         try {
            addDoc(notifRef, {
               date: serverTimestamp(),
               desc: `Admin ${user.email} has removed "${item.groupName}"`,
               seen: false,
               type: "Group Removed",
               uid: item.user,
               userEmail: item.userEmail,
               groupId: item.id,
               groupName: item.groupName,
               data: item,
            });
         } catch (error) {
            Notification("error", "Notification error", error.message);
         }
         break;
      case "CA":
         try {
            addDoc(notifRef, {
               date: serverTimestamp(),
               desc: `Admin ${user.email} has approved "${item.client}"`,
               seen: false,
               type: "Client Approved",
               uid: item.user,
               userEmail: item.userEmail,
               clientId: item.id,
               clientName: item.client,
            });
         } catch (error) {
            Notification("error", "Notification error", error.message);
         }
         break;
      case "CR":
         try {
            addDoc(notifRef, {
               date: serverTimestamp(),
               desc: `Admin ${user.email} has removed "${item.client}"`,
               seen: false,
               type: "Client Removed",
               uid: item.user,
               userEmail: item.userEmail,
               clientId: item.id,
               clientName: item.client,
               data: item,
            });
         } catch (error) {
            Notification("error", "Notification error", error.message);
            console.log(error.message);
         }
         break;

      default:
         Notification("error", "Something went wrong", "Sorry, something went wrong.");
   }
};
